import { Button } from '@repo/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { PencilIcon, Plus } from 'lucide-react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Dashboard } from '@/components/admin/insights/dashboard/Dashboard'
import { InsightWidgetConfigurationEditDialog } from '@/components/admin/insights/dashboard/EditDialog'
import { ResetAndUpdate } from '@/components/ResetAndUpdate'
import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

import { buildSearchParam, SearchParamsViewNames } from '..'

export function InsightsDashboardRoute() {
  const { t } = useT({ keyPrefix: 'admin.insights.dashboard' })
  const dispatch = useStoreDispatch()

  const widgets = useStoreState((state) => state.beneficiaryInsights.computedWidgets)
  const loading = useStoreState((state) => state.beneficiaryInsights.loading)
  const editingLayout = useStoreState((state) => state.beneficiaryInsights.editingLayout)

  useEffect(() => {
    dispatch(actions.reset())
    void dispatch(actions.getComputedWidgets())
  }, [])

  return (
    <>
      <Card className="flex flex-1 flex-col overflow-hidden bg-opacity-20">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
          <CardAction>
            {editingLayout ? (
              <ResetAndUpdate
                disabled={false}
                onReset={() => void dispatch(actions.deactivateLayoutEdit())}
                onUpdate={() => void dispatch(actions.updateInsightWidgetLayout())}
              />
            ) : (
              <Button
                variant="outline"
                className="mr-2"
                onClick={() => dispatch(actions.activateLayoutEdit())}
              >
                <PencilIcon className="size-4" />
                {t('changeLayout')}
              </Button>
            )}
            {!editingLayout && (
              <Link
                to={buildSearchParam('view', SearchParamsViewNames.INSIGHTS_LIST)}
                className="flex items-center gap-2 hover:bg-primary-100 hover:text-primary-900 dark:hover:bg-primary-800 dark:hover:text-primary-50 relative rounded-sm px-2 py-1.5 text-sm outline-none transition-colors"
              >
                <Plus className="size-4" />
                {t('addInsights')}
              </Link>
            )}
          </CardAction>
        </CardHeader>
        <CardContent className="flex flex-1 flex-col gap-4 h-full overflow-y-auto">
          <Dashboard widgets={widgets} isLoading={loading} editMode={editingLayout} />
        </CardContent>
      </Card>
      <InsightWidgetConfigurationEditDialog />
    </>
  )
}
